import { render, staticRenderFns } from "./publishQiKan.vue?vue&type=template&id=a90f9166&scoped=true&"
import script from "./publishQiKan.ts?vue&type=script&lang=ts&"
export * from "./publishQiKan.ts?vue&type=script&lang=ts&"
import style0 from "./publishQiKan.vue?vue&type=style&index=0&id=a90f9166&prod&lang=less&scoped=true&"
import style1 from "./publishQiKan.vue?vue&type=style&index=1&id=a90f9166&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90f9166",
  null
  
)

export default component.exports